import React from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const style = {
  root: {
    width: '15px',
    height: '15px',
  },
}

const RedoActiveIcon = ({ classes, className, ...props }) => (
  <SvgIcon
    {...props}
    className={cn(classes.root, className)}
    fill="none"
    viewBox="0 0 15 12"
  >
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.219 0.018744C10.2551 0.031594 10.3044 0.0551524 10.3285 0.0722857C10.3964 0.118332 13.9323 3.58355 13.9651 3.63602C14.0517 3.77202 14.0407 3.95299 13.9399 4.08363C13.8687 4.17572 10.4676 8.15815 10.4129 8.21384C10.2497 8.37981 9.97582 8.37339 9.81918 8.20099C9.7896 8.16886 9.75455 8.11532 9.74031 8.08212L9.71621 8.02323L9.71293 6.87101L9.70964 5.71772L9.68554 5.7113C9.62201 5.69631 9.25835 5.65026 9.08638 5.63634C7.99211 5.54532 6.89565 5.70594 5.86819 6.10751C4.44421 6.66327 3.16921 7.69555 2.11985 9.14225C1.65322 9.78582 1.23808 10.4958 0.822932 11.3589C0.745161 11.5184 0.692584 11.5795 0.587429 11.6298C0.522802 11.6598 0.505276 11.6641 0.416551 11.6641C0.328922 11.6641 0.310301 11.6608 0.24677 11.6309C0.118612 11.5709 0.0266009 11.4478 0.0101704 11.316C-0.000783232 11.225 0.0912276 10.5954 0.18762 10.0899C0.683821 7.50816 1.72223 5.53247 3.26998 4.2314C4.43217 3.2548 5.86271 2.66156 7.48714 2.48273C7.8289 2.44418 7.95706 2.43669 8.37658 2.43133C8.8684 2.42384 9.20358 2.4399 9.6253 2.48809L9.68883 2.49558L9.69102 1.39369L9.69431 0.291807L9.73045 0.220061C9.79618 0.0883482 9.91886 0.0112482 10.0777 0.0016107C10.1368 -0.00267264 10.1686 0.0016107 10.219 0.018744Z"
        fill="#4A4A4A"
      />
    </svg>
  </SvgIcon>
)

export default withStyles(style)(RedoActiveIcon)
